import FormatValue from './FormatValue.component';

export default FormatValue;
